/**
 * Endpoints of the PokéAPI
 */
export const ENDPOINTS = {
  BERRY: "/berry",
  BERRY_FIRMNESS: "/berry-firmness",
  BERRY_FLAVOR: "/berry-flavor",
  CONTEST_TYPE: "/contest-type",
  CONTEST_EFFECT: "/contest-effect",
  SUPER_CONTEST_EFFECT: "/super-contest-effect",
  CURRENCY: "/currency",
  ENCOUNTER_METHOD: "/encounter-method",
  ENCOUNTER_CONDITION: "/encounter-condition",
  ENCOUNTER_CONDITION_VALUE: "/encounter-condition-value",
  EVOLUTION_CHAIN: "/evolution-chain",
  EVOLUTION_TRIGGER: "/evolution-trigger",
  GENERATION: "/generation",
  POKEDEX: "/pokedex",
  VERSION: "/version",
  VERSION_GROUP: "/version-group",
  ITEM: "/item",
  ITEM_ATTRIBUTE: "/item-attribute",
  ITEM_CATEGORY: "/item-category",
  ITEM_FLING_EFFECT: "/item-fling-effect",
  ITEM_POCKET: "/item-pocket",
  LOCATION: "/location",
  LOCATION_AREA: "/location-area",
  PALPARK_AREA: "/pal-park-area",
  REGION: "/region",
  MACHINE: "/machine",
  MOVE: "/move",
  MOVE_AILMENT: "/move-ailment",
  MOVE_BATTLE_STYLE: "/move-battle-style",
  MOVE_CATEGORY: "/move-category",
  MOVE_DAMAGE_CLASS: "/move-damage-class",
  MOVE_LEARN_METHOD: "/move-learn-method",
  MOVE_TARGET: "/move-target",
  ABILITY: "/ability",
  CHARACTERISTIC: "/characteristic",
  EGG_GROUP: "/egg-group",
  GENDER: "/gender",
  GROWTH_RATE: "/growth-rate",
  NATURE: "/nature",
  POKEATHLON_STAT: "/pokeathlon-stat",
  POKEMON: "/pokemon",
  POKEMON_COLOR: "/pokemon-color",
  POKEMON_FORM: "/pokemon-form",
  POKEMON_HABITAT: "/pokemon-habitat",
  POKEMON_SHAPE: "/pokemon-shape",
  POKEMON_SPECIES: "/pokemon-species",
  STAT: "/stat",
  TYPE: "/type",
  LANGUAGE: "/language",
} as const;

type ObjectValue<T> = T[keyof T];
export type Endpoint = ObjectValue<typeof ENDPOINTS>;
